module.exports = __webpack_public_path__ + "static/media/Times New Roman-01.70aecae0.svg";